import React from "react"
import { Badge, ActionIcon, Tooltip } from "@mantine/core"
import { IconX } from "@tabler/icons-react"

const ActiveFilters = ({ filters, columns, handleRemoveFilter }) => {
  if (!filters || Object.keys(filters).length === 0) {
    return null
  }

  const uniqueConditions = new Map()

  // Collecter tous les filtres et garder seulement les uniques par condition
  Object.keys(filters).forEach(column => {
    const filterValue = filters[column]
    const columnHeader = columns.find(header => header.accessorKey === column)

    if (Array.isArray(filterValue)) {
      filterValue.forEach((filter, index) => {
        const conditionKey = `${column}_${filter.operator}`
        uniqueConditions.set(conditionKey, {
          column,
          filter,
          index,
          columnHeader,
          isArray: true,
        })
      })
    } else {
      const conditionKey = `${column}_${filterValue.operator}`
      uniqueConditions.set(conditionKey, {
        column,
        filter: filterValue,
        index: null,
        columnHeader,
        isArray: false,
      })
    }
  })

  const formatFilterValue = (filter, columnHeader) => {
    if (filter.type === "select") {
      const statut = String(filter.value)
      const statutOptions = columnHeader?.options || []
      const statutLabels = statut
        .split(",")
        .map(val => {
          const match = statutOptions.find(
            option => option.value == parseInt(val)
          )
          return match ? match.label : null
        })
        .filter(label => label !== null)
      return statutLabels.join(", ")
    }
    return filter.value
  }

  const getFilterDisplayText = (columnHeader, filter) => {
    const operatorSuffix = filter.operator === "is empty" ? "" : ":"
    const value = formatFilterValue(filter, columnHeader)
    return `${columnHeader?.header} ${filter.operator}${operatorSuffix} ${value}`
  }

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "2px",
        flex: 1,
        maxWidth: "100dvh",
      }}
      className={
        Object.keys(filters).length > 0 ? "input-group-text p-1" : "p-1"
      }
    >
      {Array.from(uniqueConditions.values()).map(
        ({ column, filter, index, columnHeader, isArray }) => {
          const displayText = getFilterDisplayText(columnHeader, filter)

          return (
            <Badge
              key={`${column}-${filter.operator}`}
              color="blue"
              style={{ maxWidth: "500px" }}
              rightSection={
                <ActionIcon
                  size="xs"
                  color="blue"
                  onClick={() =>
                    handleRemoveFilter(column, isArray ? index : undefined)
                  }
                >
                  <IconX size={10} />
                </ActionIcon>
              }
            >
              <Tooltip
                label={displayText}
                withArrow
                position="bottom"
                withinPortal
                styles={theme => ({
                  tooltip: {
                    backgroundColor: "black",
                    color: "white",
                    maxWidth: "300px",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                  },
                })}
              >
                <span
                  style={{
                    paddingTop: "6px",
                    fontWeight: "normal",
                    textTransform: "none",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "inline-block",
                    maxWidth: "100%",
                  }}
                >
                  {displayText}
                </span>
              </Tooltip>
            </Badge>
          )
        }
      )}
    </div>
  )
}

export default ActiveFilters
